export default __webpack_public_path__ + "static/media/vip-7.be795661.svg";